import {
  defaultXSMobileFontSize,
  defaultMobileFontSize,
  defaultDesktopFontSize,
} from "src/assets/jss/material-kit-react.js"

import defaultComponentStyles from "src/assets/jss/material-kit-react/defaultComponentStyles"

const filteredPropertiesStyles = theme => ({
  ...defaultComponentStyles,
  filteredPropertiesWrapper: {
    minWidth: "100%",
    paddingLeft: "0",
    paddingRight: "0",

    "& .cardBody": {
      "& .filteredPropertiesList-root": {
        listStyle: "none",
        justifyContent: "space-around",
        "& .MuiListItem-root": {
          display: "flex",
          flexDirection: "column",
          flex: "unset",
          marginBottom: theme.spacing(3),
          [theme.breakpoints.up("md")]: {
            maxWidth: "45%",
          },
          "&:nth-child(even)": {
            [theme.breakpoints.up("md")]: {
              //marginRight: 0
            },
          },
          "& .listingThumbnail-root": {
            marginBottom: theme.spacing(1),
          },

          "& .propertyInfo-root": {
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            "& *": {
              fontSize: defaultXSMobileFontSize,
              [theme.breakpoints.up("sm")]: {
                fontSize: defaultMobileFontSize,
              },
            },

            "@media (max-width: 410px), (min-width: 1024px)": {
              flexDirection: "column",
              alignItems: "center",
              "& .propertyInfo-size": {
                marginTop: theme.spacing(1),
              },
            },
          },
        },
      },
      "& ul, li": {
        padding: 0,
        margin: 0,
      },
      "& li:nth-child(even)": {
        paddingRight: 0,
      },
    },
  },
})

export default filteredPropertiesStyles
